import { ShopCheckoutResponseApi } from '../models/shop-checkout-response.model';

export type ShopCheckoutMockStrategy = 'Bemobi' | 'Eskolare';

const BEMOBI_SHOP_CHECKOUT_MOCK: ShopCheckoutResponseApi = {
  CheckoutStrategy: 'Bemobi',
  SessionToken: '5f9c2848-aa39-4280-b19a-c72bdea10988',
  RedirectUrl: null
};

const ESKOLARE_SHOP_CHECKOUT_MOCK: ShopCheckoutResponseApi = {
  CheckoutStrategy: 'Eskolare',
  SessionToken: null,
  RedirectUrl:
    'https://meu-mundo.eskolare.shop/accounts/login/powerup/b14/shop/checkout/c726731a'
};

export const SHOP_CHECKOUT_MOCKS: Record<
  ShopCheckoutMockStrategy,
  ShopCheckoutResponseApi
> = {
  Bemobi: BEMOBI_SHOP_CHECKOUT_MOCK,
  Eskolare: ESKOLARE_SHOP_CHECKOUT_MOCK
};
